import { Flex, NoRowsOverlay, BarChartIcon, DataGrid } from '@shared/components';

import { columns, type PUseListItem } from './columns';

interface PUseHistoryListProps {
  rows: PUseListItem[];
}

export default function PUseHistoryList(props: Readonly<PUseHistoryListProps>) {
  const { rows } = props;
  const defaultSelectedPUseId = rows.find((row) => row.selected)?.id || '';

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: (theme) => theme.spacing(3),
        p: (theme) => theme.spacing(6),
      }}
    >
      <DataGrid
        {...props}
        rowHeight={48}
        disableColumnMenu
        hideFooter
        sx={(theme) => ({
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: theme.palette.background.paper,
          minHeight: '100%',
          '.MuiDataGrid-cell': {
            p: theme.spacing(3),
          },
          '.MuiButtonBase-root': {
            p: theme.spacing(0),
          },
          '.MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
            display: 'none',
          },
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: theme.palette.grey[100],
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '.MuiDataGrid-columnHeader': {
            px: theme.spacing(3),
          },
          '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
            borderBottom: `1px solid ${theme.palette.grey[300]}`,
          },
          '--DataGrid-overlayHeight': '404px',
        })}
        columns={columns}
        rows={rows}
        disableRowSelectionOnClick
        rowSelectionModel={defaultSelectedPUseId}
        slots={{
          noRowsOverlay: () => (
            <NoRowsOverlay
              icon={BarChartIcon}
              title='ยังไม่มีข้อมูลสถิติ'
              description='ไม่พบประวัติค่า P เนื่องจากคำถามนี้อาจยังไม่ถูกใช้งาน หรือยังไม่มีการอัปเดตข้อมูลจาก Report'
            />
          ),
        }}
      />
    </Flex>
  );
}
